import arrayToTree from 'array-to-tree'

const listTree = (state) => {
  if (!state.list) {
    return []
  }
  return arrayToTree(state.list.map(item => _.pick(item, ['id', 'parent_id', 'nome', 'user.id', 'user.name'])))
}

export default {
  listTree
}



// WEBPACK FOOTER //
// ./src/features/Centro/store/getters.js